(function() {

        const errors = {
            valueRequired: window.theme.formErrors.valueRequired,
            emailNoAt: window.theme.formErrors.emailNoAt,
            passwordShort: window.theme.formErrors.passwordShort,
            passwordMismatch: window.theme.formErrors.passwordMismatch
        };


    function validateFields(e) {
        // Get the  value of the input field being submitted

        const target = e.target;

        if(target.hasAttribute("data-val-email")){
            const val = target.value;
            const $msg = target.parentElement.nextElementSibling;
            if (val === '') {
                return;
            }
            if (val.search('@') === -1) {
                $msg.innerText = errors.emailNoAt;
                $msg.classList.remove('hide');
                $msg.setAttribute('aria-hidden', false);
            } else {
                $msg.innerText = '';
                $msg.classList.add('hide');
                $msg.setAttribute('aria-hidden', true);
            }
        }

        if(target.hasAttribute("data-val-pass")){
            const val = target.value;
            const $msg = target.parentElement.nextElementSibling;
            if (val === '') {
                return;
            }
            if (val.length < 6) {
                $msg.innerText = errors.passwordShort
                $msg.classList.remove('hide')
                $msg.setAttribute('aria-hidden', false);
            } else {
                $msg.innerText = '';
                $msg.classList.add('hide');
                $msg.setAttribute('aria-hidden', true);
            }
        }
    }

    function validateRequiredFields(e) {
        const target = e.target;
        const val = target.value;
        const $msg = target.parentElement.nextElementSibling;
        if (val === '') {
            e.preventDefault();
            $msg.innerText = errors.valueRequired
            $msg.classList.remove('hide')
            $msg.setAttribute('aria-hidden', false);
        } else {
            $msg.innerText = '';
            $msg.classList.add('hide');
            $msg.setAttribute('aria-hidden', true);
        }
    }

    function validateSubmit(e, formInputs) {

        formInputs.forEach( formInput => {
            const val = formInput.value;
            const $msg = formInput.parentElement.nextElementSibling;
            if(formInput.hasAttribute("data-val-email")){

                if (val.length === 0) {
                    $msg.innerText = errors.valueRequired
                    $msg.classList.remove('hide')
                    $msg.setAttribute('aria-hidden', false);
                    e.preventDefault();
                } else if (val.length > 0 && val.search('@') === -1) {
                    $msg.innerText = errors.emailNoAt;
                    $msg.classList.remove('hide');
                    $msg.setAttribute('aria-hidden', false);
                    e.preventDefault();
                } else {
                    $msg.innerText = '';
                    $msg.classList.add('hide');
                    $msg.setAttribute('aria-hidden', true);
                }
            }

            if(formInput.hasAttribute("data-val-pass")){

                if (val.length === 0) {
                    $msg.innerText = errors.valueRequired
                    $msg.classList.remove('hide')
                    $msg.setAttribute('aria-hidden', false);
                    e.preventDefault();
                }else if (val.length > 0 && val.length < 6) {
                    $msg.innerText = errors.passwordShort
                    $msg.classList.remove('hide')
                    $msg.setAttribute('aria-hidden', false);
                    e.preventDefault();
                } else {
                    $msg.innerText = '';
                    $msg.classList.add('hide');
                    $msg.setAttribute('aria-hidden', true);
                }
            }
        })

    }


        function init() {
            let formInputs = document.querySelectorAll('#nav-account form input[data-val-required]');
            let forms = document.querySelectorAll('#nav-account form');

            formInputs.forEach(formInput => {
                formInput.addEventListener('blur', (e) => validateFields(e));
                formInput.addEventListener('blur', (e) => validateRequiredFields(e));
            });

            forms.forEach(form => {
                form.addEventListener('submit', (e) => validateSubmit(e, formInputs));
            });

        }

        init();

}());